<section *ngIf="processing">
    <h2>{{processingMessage}}...</h2>
    <mat-progress-bar mode="indeterminate" color="warn" aria-label="processing...">
    </mat-progress-bar>
  </section>

  <section *ngIf="!processing">
    <!-- Action Buttons -->
    <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
        <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
          <h2 class="noMarginHeader"><mat-icon>note_add</mat-icon> Generate Exceedance Letter {{voucher.voucherId}}</h2>
        </div>
        <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="end">
          <button type="submit" name="SubmitButton" (click)="onSubmit()" mat-raised-button color="primary" value="Save" title="Save" [disabled]="!canSave">Save</button>
          &nbsp;&nbsp;
          <button mat-button mat-dialog-close="Cancel" mat-raised-button color="basic" aria-label="Cancel">Cancel</button>
        </div>
      </div>
      <hr />
  </section>

<mat-dialog-content  id="voucherLetterPdf">

<Header>
    <img src="{{environment.baseUrl}}/assets/images/OregonWell_Letterheader.png" 
        alt="Letter Header">
</Header>
<body style="font-family: 'Arial'; ">
    <p style='color:green;font-size:24px'>{{voucher?.applicantContactName}}<br>
        {{voucher?.applicantAddress}}<br>
        {{voucher?.applicantCity}} {{voucher?.applicantState}} {{voucher?.applicantZip}}</p>
    <p style='font-size:24px'>You recently used a voucher
        to test the water from your private well that was impacted by the 2020
        wildfires. We are writing to tell you about a high result from the sample
        tested. </p>
    <p style='font-size:24px'>The following contaminant was detected at unsafe levels (above the Safe Drinking Water Standard*)<span *ngIf="parameterResult.labName != null && parameterResult.labName.length > 0"> by : <strong><span style='color:green'>{{parameterResult.labName}}</span></strong></span>:</p>
        <p style='margin-left:.5in'>
            <strong style='font-size:24px'>Contaminant: </strong><span style='color:green;font-size:24px'>{{parameterResult.contaminant}}</span><br>
            <strong style='font-size:24px'>Result(Units): </strong><span style='color:green;font-size:24px'>{{parameterResult.result}} <span *ngIf="parameterResult.units != null && parameterResult.units.length > 0">({{ parameterResult.units}})</span></span><br>
            <strong style='font-size:24px'>Analysis Date: </strong><span style='color:green;font-size:24px'>{{parameterResult.analysisDate}}</span><br>
            <strong style='font-size:24px'>Analytical Method: </strong><span style='color:green;font-size:24px'>{{parameterResult.analysisMethod}}</span></p>
                
    <p style='font-size:24px'>Contaminated water can be a
        health risk. We recommend that you, and others on the property, drink potable
        (clean) water from another source until the contamination is addressed.</p>
                
    <p style='font-size:24px'>With this letter, we have
        included a factsheet(s) with information about the contaminants in your well water. More information is 
        also available online at <a href="http://www.healthoregon.org/wells"><u>www.healthoregon.org/wells</u></a>.</p>
                
    <p style='font-size:24px'>If you or other members of
        the household have health concerns, we encourage you to talk with your doctor.
        If you have any questions about your water quality, testing recommendations and
        general tips on how to keep your well water “well”, please do not hesitate to
        contact us. For treatment questions, call the National Sanitation Foundation (<a
        href="http://www.nsf.org/consumer-resources/what-is-nsf-certification/water-filters-treatment-certification/selecting-a-water-treatment-system/">
        <u>NSF</u></a>) at 1-800-673-8010.</p>

    <p style='font-size:24px'>Sincerely, </p>

    <p><img src="{{environment.baseUrl}}/assets/images/odwsp-color.LOWREZ.png" alt="OregonWell Logo"></p>

    <p style='font-size:18px'><em>*Public water systems are tested for more than 90 contaminants and
        evaluated based on Safe Drinking Water Standards set by the Environmental
        Protection Agency (EPA). Domestic wells, or shared wells with three or fewer
        connections are not regulated and have no set standards. </em></p>
</body> 
</mat-dialog-content>